module.exports = __webpack_public_path__ + "media/images/vp/icon.mail.black-476e7a51998d06aa93ca8ef3c5e7c80b.svg";